export const keyConstants = {
    ENTER: 13
  };